"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thumbs = exports.provider = exports.title = exports.headerWrapper = void 0;

var react_1 = require("@emotion/react");

exports.headerWrapper = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  min-height: 40px;\n  margin-bottom: 26px;\n"])));
exports.title = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: calc(100% - 80px);\n  color: var(--white);\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 4px;\n"])));
exports.provider = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  opacity: 0.5;\n  color: var(--white);\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.2px;\n"])));
exports.thumbs = react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: transparent;\n"])));